import { Card } from "@/components/ui/card";
import { MessagesPanel } from "@/components/MessagesPanel";

export default function Messages() {
  return (
    <div className="mx-auto max-w-2xl" data-testid="manager-messages-page">
      <Card className="p-4 sm:p-6">
        <MessagesPanel />
      </Card>
    </div>
  );
}
